import { Component, Input, OnInit } from '@angular/core';
import { UtilityCounts } from 'src/app/core/interfaces/status-counts/utility-counts';

@Component({
  selector: 'app-utility-counts',
  templateUrl: './utility-counts.component.html',
  styleUrls: ['./utility-counts.component.scss'],
})
export class UtilityCountsComponent implements OnInit {
  @Input() utilityCounts: UtilityCounts;

  constructor() {}

  ngOnInit(): void {}
}
